export default {
    apiLogout(data={}, urldata = {}) {
        const redirect = ()=>{
            app.props.setstore("auth", false);
            app.props.setstore("user", false);
            localStorage.clear();
            navigate("/login");
        };
        if(data.skipApi) { return redirect(); }
        return this.request(this.api().postLogout, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().mapresults((responce) => {
                redirect();
            }).get();
    },
    apiFetchUser(data, urldata = {}) {
        return this.request(this.api().getMe, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().mapresults((responce) => {
                let data = responce.data;
                let { items } = data;
                let [ user ] = items;
                console.log("apiLogin",user);
                if (!user) { return responce; }
                app.props.setstore("user", user);
            }).get();
    },
    apiLogin(data, urldata = {}) {
        return this.request(this.api().postLogin, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().mapresults(async (responce) => {
                let data = responce.data;
                if (!data) { return responce; }
                app.props.setstore("authObj", data);
                app.props.setstore("auth", data.access_token);
                await this.apiFetchUser();
                return responce;
            }).get();
    },
    apiResetPassword(data, urldata = {}) {
        return this.request(this.api().postReset, data)
            .urltransform({
                ...urldata,
                ...mixins.params()
            })
            .exec().log().get();
    },
    apiRefreshToken(data={}, urldata = {}) {
        return this.request(this.api().postRefresh, data,{
            refresh:app.props.store.authObj.refresh_token
        }).urltransform({
            ...urldata,
            ...mixins.params()
        }).exec().log()
        .mapresults(async (responce) => {
            let data = responce.data;
            app.props.setstore("authObj", data);
            app.props.setstore("auth", data.access_token);
        }).get();
    }
}